import $store from '../store'
import { AuthService } from '@/services/auth.service'
import { isPermitionAllowed, isPermitionAllowedForRole } from '@/permissions';

/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
export async function initCurrentUserStateMiddleware (to, from, next) {
  const currentUserId = $store.state.user.currentUser.id
    
  let accessTokenIsEmpty = AuthService.accessTokenIsEmpty()

  if (accessTokenIsEmpty) {
    console.log(`accessTokenIsEmpty = ${accessTokenIsEmpty}`)
  }

  // обновление аксес-токена при наличии рефреш-токена
  if (AuthService.hasRefreshToken() && (!currentUserId || accessTokenIsEmpty)         
        && !to.fullPath.includes("/login?") && !to.fullPath.includes("/login/")) {  // кроме аутентификации по коду, для нее не обновляем  
    try {
      await AuthService.debounceRefreshTokens()
      await $store.dispatch("user/getCurrent", { from: 'initCurrentUserStateMiddleware' })      
      next()
    } catch (e) {
      console.log(e)
    }
  } else {
    next()
  }
}

/**
 * Check access permission to auth routes
 */
export function checkAccessMiddleware (to, from, next) {
  const currentUserId = $store.state.user.currentUser.id

  const isDevRoute = to.matched.some(item => item.meta.isDevRoute)

  if (isDevRoute && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'demo')) {
    console.log('redirect to /not-found')
    return next('/not-found')
  } 

  const checkPermitions = to.matched.some(item => item.meta.checkPermitions)
  const userRole = $store.getters['user/getRoleCurentUser']

  // проверяем доступен ли переход для роли пользователя (если пользователь залогинен)
  if (currentUserId && checkPermitions && !isPermitionAllowedForRole(to.name, userRole)) {   
    console.log(`not allowed transition to ${to.name} for role '${userRole}'`)
    console.log('redirect to /not-found')
    return next('/not-found')
  }

  const isAuthRoute = to.matched.some(item => item.meta.isAuth)

  if (currentUserId) {
    // авторизованного пользователя при попытке перейти на /login перекидываем на /finances/payslips
    if (to.fullPath === '/login') {
      console.log('redirect to /finances/payslips')
      return next('/finances/payslips') 
    }

    //if (isAuthRoute) return next()
  } else {
    // при переходе на приватный путь неавторизованного пользователя просим залогиниться
    if (isAuthRoute) {
      console.log('redirect to /login')
      return next({ name: 'login' })
    }
  }

  next()
}

export function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)

  if (pageTitle) window.document.title = pageTitle.meta.title
  
  next()
}
